const bulkOrderForm = () => {
    const selectors = {
        bulkOrderFormSection: '[data-bulk-order-form]',
        bulkOrderFormInputs: '.bulk-order-form__table input[type="number"]',
        bulkOrderFormSizeTotal: '.size-total',
        bulkOrderFormOrderTotal: '[data-bulk-order-total]',
        bulkOrderFormAddToCart: '[data-bulk-order-add-to-cart]',
    };
    const bulkOrderFormSections = document.querySelectorAll(selectors.bulkOrderFormSection);
    bulkOrderFormSections.forEach((section) => {
        const inputs = section.querySelectorAll(selectors.bulkOrderFormInputs);
        const orderTotal = section.querySelector(selectors.bulkOrderFormOrderTotal);
        const addToCartButton = section.querySelector(selectors.bulkOrderFormAddToCart);
        const updateTotals = () => {
            const sizeTotals = {};
            let totalQuantity = 0;
            const footerTotals = section.querySelectorAll(selectors.bulkOrderFormSizeTotal);
            inputs.forEach((input) => {
                const size = input.dataset.variantSize;
                const value = parseInt(input.value) || 0;
                if (!sizeTotals[size]) {
                    sizeTotals[size] = 0;
                }
                if (value) {
                    input.parentElement.classList.add('has-value');
                }
                else {
                    input.parentElement.classList.remove('has-value');
                }
                if (value > 0) {
                    input.parentElement.classList.add('add-bg');
                }
                else {
                    input.parentElement.classList.remove('add-bg');
                }
                sizeTotals[size] += value;
                totalQuantity += value;
            });
            footerTotals.forEach((totalCell) => {
                const size = totalCell.dataset.sizeTotal;
                const total = sizeTotals[size] || 0;
                totalCell.textContent = total;
            });
            if (totalQuantity === 0) {
                orderTotal.textContent = 'Enter quantities above';
            }
            else {
                orderTotal.textContent = 'Total Quantity: ' + totalQuantity.toString();
            }
        };
        inputs.forEach((input) => {
            input.addEventListener('input', updateTotals);
        });
        const buildFormData = () => {
            const items = [];
            inputs.forEach((input) => {
                const quantity = parseInt(input.value);
                const variantId = parseInt(input.dataset.variantId);
                if (!isNaN(quantity) && quantity > 0 && variantId) {
                    items.push({
                        id: variantId,
                        quantity: quantity,
                    });
                }
            });
            return { items };
        };
        if (addToCartButton) {
            addToCartButton.addEventListener('click', function () {
                const formData = buildFormData();
                if (formData.items.length === 0) {
                    alert('Please enter at least one quantity.');
                    return;
                }
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                })
                    .then((response) => response.json())
                    .then((data) => {
                    document.dispatchEvent(new CustomEvent('variant:add'));
                    document.dispatchEvent(new CustomEvent('cart:refresh'));
                    inputs.forEach((input) => {
                        input.value = '';
                        updateTotals();
                    });
                })
                    .catch((error) => {
                    console.error('Error:', error);
                });
            });
        }
    });
};
export { bulkOrderForm };
